<template>
  <div :class="['chart-box', { full }]">
    <LoadingIndicator v-if="busy" />
    <template v-else>
      <div class="title">
        <p>{{ title }}</p>
        <Button class="link" :href="`/analysis/${target}/?endTerm=${this.yearMonth}&unit=${unit}`" small>詳細</Button>
      </div>
      <div v-if="Object.keys(detail).length" class="head">
        <div class="info">
          <span class="label">{{ isCancel ? 'キャンセル率' : '1位' }}</span>
          <div class="fluctuation">
            <span class="type">前月</span>
            <FluctuationIcon :type="detail.fluctuationType" />
            <span v-if="detail.fluctuationValue" class="operator">{{ toOperator(detail.fluctuationType) }}</span>
            <span v-else class="no-value">-</span>
            <span class="value">{{ rateFormat(detail.fluctuationValue) }}{{ isCancel ? '%' : '件' }}</span>
          </div>
        </div>
        <div class="detail">
          <span v-if="detail.number !== null" class="number">{{ detail.number }}</span>
          <span v-else class="no-value">-</span>
          <span class="suffix">{{ isCancel ? '%' : '件' }}</span>
          <span :class="['name', { small: isCancel }]">{{ detail.name }}</span>
        </div>
      </div>
      <slot name="body">
        <Chart v-if="data" :type="type" :data="data" :options="options" />
        <div v-else class="no-data">表示する内容がありません</div>
        <p class="note">（{{ note }}）</p>
      </slot>
    </template>
  </div>
</template>

<script>
import { toOperator } from '@/utils/analysis'
import { rateFormat } from '@/utils/number'
import LoadingIndicator from '@/components/molecules/LoadingIndicator'
import Button from '@/components/atoms/Button'
import Chart from '@/components/molecules/Chart'
import FluctuationIcon from './FluctuationIcon'

export default {
  name: 'ChartBox',
  components: {
    LoadingIndicator,
    Button,
    Chart,
    FluctuationIcon,
  },
  props: {
    busy: { type: Boolean, default: false },
    full: { type: Boolean, default: false },
    title: { type: String },
    target: { type: String },
    unit: { type: String, default: '2' },
    note: { type: String, default: '予約組数' },
    detail: { type: Object, default: () => ({}) },
    type: { type: String, default: 'BarChart' },
    data: { type: Array, default: () => [] },
    options: { type: Object, default: () => ({}) },
    isCancel: { type: Boolean, default: false },
    yearMonth: { type: String },
  },
  computed: {},
  methods: {
    toOperator,
    rateFormat(value) {
      if (!value) return ''
      return this.isCancel ? rateFormat(value) : value
    },
  },
}
</script>

<style lang="postcss" scoped>
.chart-box {
  background: var(--white);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  min-height: 396px;
  padding: 24px 24px 18px;
  position: relative;
  width: calc((100% - 16px) / 2);
}

.full {
  width: 100%;
}

.title {
  align-items: center;
  border-bottom: solid 1px var(--border-color);
  display: flex;
  font-size: 21px;
  font-weight: bold;
  justify-content: space-between;
  line-height: 1;
  margin-bottom: 16px;
  padding-bottom: 16px;

  >>> .button {
    width: 80px;
  }
}

.head {
  border-bottom: solid 1px var(--border-color);
  margin-bottom: 16px;
  padding-bottom: 16px;
}

.info {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
}

.label {
  align-items: center;
  background: var(--very-dark-gray);
  box-sizing: border-box;
  color: var(--white);
  display: grid;
  font-size: 11px;
  height: 16px;
  line-height: 16px;
  padding: 0 7px;
  text-align: center;
}

.fluctuation {
  align-items: center;
  display: flex;
  font-size: 11px;
  line-height: 1;

  >>> svg {
    height: 16px;
    width: 16px;
  }
}

.no-value {
  font-weight: 600;
  line-height: 1;
  text-align: center;
  width: 1em;
}

.detail {
  align-items: flex-end;
  display: flex;
  margin-top: 8px;
  min-height: 32px;

  .number {
    flex: 0 0 auto;
    font-size: 38px;
    font-weight: bold;
    line-height: 32px;
  }

  .suffix {
    font-weight: bold;
    line-height: 1;
    margin-left: 4px;
  }
}

.name {
  font-size: 16px;
  font-weight: bold;
  line-height: 1;
  margin-left: 8px;

  &.small {
    font-size: 11px;
  }
}

.operator,
.value {
  font-weight: bold;
}

.no-data {
  align-items: center;
  display: inline-flex;
  flex: 1 0 auto;
  justify-content: center;
}

.note {
  color: var(--dark-gray);
  font-size: 10px;
  margin-top: 8px;
  text-align: right;
}

.responsive {
  .chart-box {
    margin-top: 8px;
    padding: 24px 16px 20px;
    width: 100%;

    &:last-child {
      margin-bottom: 32px;
    }
  }

  .link {
    display: none;
  }
}
</style>
